exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Logo__logo___1GLie {\n  display: inline-block;\n  margin-top: 8px;\n  height: 57px;\n  width: 138px; }\n", ""]);

// exports
exports.locals = {
	"logo": "Logo__logo___1GLie"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/Footer/Logo/Logo.scss
// module id = 2068
// module chunks = 6